<div class="review-container">

    <div class="review-header" *ngIf="isPaid">
        <h3>Question-by-Question Review</h3>
     </div>

          <div class="locked-evaluation-row" *ngIf="!isPaid">
             <div class="lock-icon">
               <i class="bi bi-lock"></i>
        </div>
             <p class="locked-text">Full evaluation report locked</p>
               <button class="btn-add" routerLink="/student-dashboard/upgrade-plan">Upgrade now</button>
           </div>

    
    <div class="nav-strip" *ngIf="isPaid">
        <div class="legend">
            <span>Jump to:</span>
            <div class="legend-item"><span class="dot correct"></span> Correct</div>
            <div class="legend-item"><span class="dot wrong"></span> Wrong</div>
            <div class="legend-item"><span class="dot skipped"></span> Skipped</div>
        </div>
        <div class="bubbles-scroll">
            <button *ngFor="let q of questions; let i = index" class="nav-bubble"
                [ngClass]="[getStatusClass(q), currentIndex === i ? 'active' : '']" (click)="selectQuestion(i)">
                {{ i + 1 }}
            </button>
        </div>
    </div>


    
    <div class="questions-scroll-container" #scrollContainer>
        <div class="question-card" *ngFor="let q of questions; let index = index" [id]="'question-' + index"
            #questionItem>
            <div class="card-header">
                <div class="q-number-badge" [ngClass]="getStatusClass(q)">
                    {{ index + 1 }}
                </div>
                <div class="q-content">
                    <h4 class="q-text">{{ q.question.question_text }}</h4>
                </div>
                <div class="status-badge" *ngIf="isCorrect(q)">
                    <span class="badge correct">✓ Correct</span>
                </div>
                <div class="status-badge" *ngIf="isWrong(q)">
                    <span class="badge wrong">✕ Incorrect</span>
                </div>
                <div class="status-badge" *ngIf="isSkipped(q)">
                    <span class="badge skipped">⚠ Skipped</span>
                </div>
            </div>

            <div class="options-container">
                <div *ngFor="let option of q.question.options; let optIndex = index" class="option-row" [ngClass]="{
                        'correct-highlight': isOptionCorrect(q, option),
                        'wrong-highlight': isOptionSelected(q, option) && !isOptionCorrect(q, option),
                        'selected': isOptionSelected(q, option)
                    }">
                    <div class="opt-label">{{ getOptionLetter(optIndex) }}</div>
                    <div class="opt-text">{{ option.text }}</div>
                    <div class="opt-icon" *ngIf="isOptionCorrect(q, option)">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                    </div>
                    <div class="opt-icon" *ngIf="isOptionSelected(q, option) && !isOptionCorrect(q, option)">
                        <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                            <path
                                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                    </div>
                </div>
            </div>

            <div class="info-section explanation">
                <div class="section-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
                        <path
                            d="M9.00003 21H15C15.55 21 16 20.55 16 20V19H8.00003V20C8.00003 20.55 8.45003 21 9.00003 21ZM12 2C8.14003 2 5.00003 5.14 5.00003 9C5.00003 11.38 6.19003 13.47 8.00003 14.74V17C8.00003 17.55 8.45003 18 9.00003 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2Z" />
                    </svg>
                    Explanation
                </div>
                <div class="section-content">
                    {{ q.evaluation?.explanation }}
                </div>
            </div>

            <div class="info-section feedback">
                <div class="section-title">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" width="18" height="18">
                        <path
                            d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V7h2v3z" />
                    </svg>
                    Feedback
                </div>
                <div class="section-content">
                    {{ q.evaluation?.feedback }}
                </div>
            </div>
        </div>
    </div>
</div>